module.exports = require("react-copy-to-clipboard");


//////////////////
// WEBPACK FOOTER
// external "react-copy-to-clipboard"
// module id = 298
// module chunks = 0